export default {
  '/masterData/dataFlow/getDataFlowSystemLevel?entityId=67': {
    method: 'get',
    reply: 200,
    data: {
      status: '0',
      msg: 'success',
      data: {
        entityName: 'Customer Profile Info',
        dataFlowListVos: [
          {
            nodes: [
              {
                nodeId: '41850751-300e-4168-9ee9-f21a756eb386',
                nodeAppId: '301',
                nodeAppName: 'cus_sem_cdl_dim_cus_cdm_customer_profile_t',
                nodeType: 'Trusted Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-02338',
                nodeHoverName: 'CDP',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '1f8ac59e-2c93-40f8-9409-86c2f7b891e7',
                    nodeChildName: 'cdmid',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [265],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '18377b41-2cc9-41f5-8f61-d650297ccd5a',
                    nodeChildName: 'customer_type',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [267],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '477d6dc9-da06-4d38-b64d-e653b4f65077',
                    nodeChildName: 'mobile_phone_number',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [282],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'd44c5391-2bb1-4c85-9ac5-38bb3544c6d7',
                    nodeChildName: 'last_name',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [268],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'b9bfef12-1089-4ea1-95af-1f8fee55fa5d',
                    nodeChildName: 'first_name',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [269],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '9484589b-c587-4516-b3af-be8ca91f23fd',
                    nodeChildName: 'full_name',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [270],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '6557c006-872b-4b2c-98f7-a20c118d78b5',
                    nodeChildName: 'gender',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [271],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'b0d13268-aae1-4770-a15e-1fd9b55a328b',
                    nodeChildName: 'age',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [272],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '10ffb3a7-348f-4d54-ac58-a1228dc04f0b',
                    nodeChildName: 'birth_date',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [273],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '52d75026-1f01-4f95-a1f4-c06f89c73607',
                    nodeChildName: 'marital_status',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [274],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '7b5addd5-a397-46b9-a680-01e1139384ac',
                    nodeChildName: 'kids_number',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [297],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '0b27be6d-ceeb-4c8d-9309-e3ed57636c9a',
                    nodeChildName: 'education',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [275],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '3817161b-054d-4015-b9b6-14a52a16427c',
                    nodeChildName: 'religion',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [298],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '2abe13c9-d434-41bc-a715-74fa9074edca',
                    nodeChildName: 'country',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [276],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '39218060-a528-4409-94e1-57fd157e4e00',
                    nodeChildName: 'region',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [277],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'bdd426b5-2c3d-4b87-a7b6-f24e0495480a',
                    nodeChildName: 'province',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [278],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '9270ca16-6847-49c0-8208-4a0f774abbbb',
                    nodeChildName: 'city',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [279],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '7a0db5c3-98b9-4d14-9ce5-60d4f0f24e2c',
                    nodeChildName: 'district',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [280],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '8406a1c7-ba37-470f-b3d0-40f1cf1bf840',
                    nodeChildName: 'address',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [281],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'e1ae321a-9260-4c8b-94d2-676b7d6c556c',
                    nodeChildName: 'email_address_business',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [283],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '8d744632-7854-49bc-ac5f-d45a506c2e43',
                    nodeChildName: 'email_address_private',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [284],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'ab5f5e91-6fac-4b2f-b2f6-18faf79ea3d4',
                    nodeChildName: 'postcode',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [285],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '4245b29d-3656-4ba0-8ad8-02d39cb07f48',
                    nodeChildName: 'profession',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [299],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'b5405f5e-60ad-41ea-ac5d-2682f5b314d4',
                    nodeChildName: 'industry',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [300],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '351eab7c-0aee-4492-b91b-1650b673873b',
                    nodeChildName: 'hobby',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [301],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '83196291-fc98-46d8-83f1-cf4eaff22034',
                    nodeChildName: 'id_number',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [286],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'af3ec3a7-3a25-429b-b6e2-a70b07b1f35e',
                    nodeChildName: 'company_id',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [287],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '5f217193-3ab4-4587-9d76-9939f59c1ce3',
                    nodeChildName: 'company_name',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [288],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'ef8d3285-7f00-4fdb-8683-41330e862d3c',
                    nodeChildName: 'taxpayer_identity_number',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [289],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '5dd56bda-778f-497c-ba27-17662c6577ac',
                    nodeChildName: 'customer_group',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [290],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'ee0bf166-ed6d-4b0f-9f03-22b79dfd3c3c',
                    nodeChildName: 'optin_optout',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [293],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '7803ab67-68cb-499d-9fa1-c852040a8c0d',
                    nodeChildName: 'mobilephone_optin_optout',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [295],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'cde14d12-c34a-4426-97a9-cd33bb6f7fd0',
                    nodeChildName: 'email_optin_optout',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [291],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'd17081e1-3cba-4542-91f0-c2813d6052cc',
                    nodeChildName: 'sms_optin_optout',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [292],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '48c23da7-0d3c-4ac9-ae4f-b71c1af0261c',
                    nodeChildName: 'mms_optin_optout',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [294],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: '8b465191-f823-4d7e-bdfa-9ee1116ebe23',
                    nodeChildName: 'wechat_optin_optout',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [296],
                    nodeAppId: null,
                  },
                  {
                    nodeChildId: 'e02a6f16-7b77-4a91-8d17-0d20763ad466',
                    nodeChildName: 'cop_id',
                    nodeParentId: '41850751-300e-4168-9ee9-f21a756eb386',
                    tableId: 301,
                    attrIds: [266],
                    nodeAppId: null,
                  },
                ],
              },
              {
                nodeId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                nodeAppId: '288',
                nodeAppName: 'cus_sem_dwc_dim_cus_gcdm_customer_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-15255',
                nodeHoverName: 'GCDM IAM CN',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '18a9cfde-afaf-4bb1-b30c-97a007ea5ed1',
                    nodeChildName: 'birth_date',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [273],
                    nodeAppId: '288',
                  },
                  {
                    nodeChildId: '860ed516-2cf0-4c61-9e8f-66f54579c677',
                    nodeChildName: 'customer_group',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [290],
                    nodeAppId: '288',
                  },
                  {
                    nodeChildId: '02b492ce-cae5-4175-9753-ca4492e82857',
                    nodeChildName: 'customer_type',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [267],
                    nodeAppId: '288',
                  },
                  {
                    nodeChildId: '5ccc7038-b3e1-41a7-a4f7-e4b56cbb5046',
                    nodeChildName: 'first_name',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [269],
                    nodeAppId: '288',
                  },
                  {
                    nodeChildId: '227c7de5-b58d-4390-8e2a-3c9ddd1d7f25',
                    nodeChildName: 'gender',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [271],
                    nodeAppId: '288',
                  },
                  {
                    nodeChildId: '0c154048-03ce-4cd0-8e78-51f26fb7fb19',
                    nodeChildName: 'hobby',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [301],
                    nodeAppId: '288',
                  },
                  {
                    nodeChildId: '8cdbe69a-d65e-4dd9-8e10-f8bae72fae30',
                    nodeChildName: 'last_name',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [268],
                    nodeAppId: '288',
                  },
                  {
                    nodeChildId: '6f2e0dcd-15d9-4837-92db-71b4568e1710',
                    nodeChildName: 'marital_status',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [274],
                    nodeAppId: '288',
                  },
                  {
                    nodeChildId: '62721a06-8996-44f6-8952-a2e54308debf',
                    nodeChildName: 'profession',
                    nodeParentId: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                    tableId: 288,
                    attrIds: [299],
                    nodeAppId: '288',
                  },
                ],
              },
              {
                nodeId: 'f3a47e30-7467-4bb0-ba7a-976a1acff9c7',
                nodeAppId: '289',
                nodeAppName: 'cus_sem_dwc_dim_cus_gcdm_customer_policy_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-15255',
                nodeHoverName: 'GCDM IAM CN',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: 'b566bb51-b5e3-47e7-b7a8-6c95c98e1c6d',
                    nodeChildName: 'data_usage_revoked',
                    nodeParentId: 'f3a47e30-7467-4bb0-ba7a-976a1acff9c7',
                    tableId: 289,
                    attrIds: [291],
                    nodeAppId: '289',
                  },
                  {
                    nodeChildId: '30007713-6d2c-48ec-9d0e-11b5248122f2',
                    nodeChildName: 'data_usage_type',
                    nodeParentId: 'f3a47e30-7467-4bb0-ba7a-976a1acff9c7',
                    tableId: 289,
                    attrIds: [291],
                    nodeAppId: '289',
                  },
                ],
              },
              {
                nodeId: 'be94fe92-051e-45c1-9626-9c7f00955f15',
                nodeAppId: '290',
                nodeAppName: 'cus_sem_dwc_dim_com_dmo2_customer_address_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-01963',
                nodeHoverName: 'DMO',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '75bcc6a3-7bc8-405d-8cee-7e361884bc43',
                    nodeChildName: 'address_detail',
                    nodeParentId: 'be94fe92-051e-45c1-9626-9c7f00955f15',
                    tableId: 290,
                    attrIds: [281],
                    nodeAppId: '290',
                  },
                  {
                    nodeChildId: '6a9222e2-eeae-4216-abca-5230ecae76c5',
                    nodeChildName: 'postcode',
                    nodeParentId: 'be94fe92-051e-45c1-9626-9c7f00955f15',
                    tableId: 290,
                    attrIds: [285],
                    nodeAppId: '290',
                  },
                ],
              },
              {
                nodeId: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                nodeAppId: '291',
                nodeAppName: 'cus_sem_dwc_dim_cus_dmo2_company_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-01963',
                nodeHoverName: 'DMO',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '83680182-bc67-4fd5-ad1b-8e0ea15f2319',
                    nodeChildName: 'company_name',
                    nodeParentId: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                    tableId: 291,
                    attrIds: [288],
                    nodeAppId: '291',
                  },
                  {
                    nodeChildId: '75d0cdf3-0ebe-4866-87f3-03b45cea4c4d',
                    nodeChildName: 'address',
                    nodeParentId: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                    tableId: 291,
                    attrIds: [281],
                    nodeAppId: '291',
                  },
                  {
                    nodeChildId: '5f3623dd-3d28-4053-b928-e482991915c5',
                    nodeChildName: 'taxpayer_identity_number',
                    nodeParentId: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                    tableId: 291,
                    attrIds: [289],
                    nodeAppId: '291',
                  },
                  {
                    nodeChildId: 'da058cb6-a5a2-45ab-a214-f6ee899cd580',
                    nodeChildName: 'spark_id',
                    nodeParentId: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                    tableId: 291,
                    attrIds: [267],
                    nodeAppId: '291',
                  },
                  {
                    nodeChildId: '7e078fee-d5bd-4e89-b9c4-5fbd8b63d50b',
                    nodeChildName: 'phone_number',
                    nodeParentId: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                    tableId: 291,
                    attrIds: [282],
                    nodeAppId: '291',
                  },
                  {
                    nodeChildId: 'e1ba3d81-cdc1-42f3-87d7-cd46b9c6df37',
                    nodeChildName: 'dealer_id',
                    nodeParentId: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                    tableId: 291,
                    attrIds: [267],
                    nodeAppId: '291',
                  },
                ],
              },
              {
                nodeId: '8c71b891-77bc-4e4e-8b6d-e5d4e1c33a86',
                nodeAppId: '299',
                nodeAppName: 'cus_sem_dwc_fact_cus_wechat_subscribe_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-02338',
                nodeHoverName: 'CDP',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '668231bf-10e4-4e85-a787-7f26790dc8d5',
                    nodeChildName: 'subscribe_status',
                    nodeParentId: '8c71b891-77bc-4e4e-8b6d-e5d4e1c33a86',
                    tableId: 299,
                    attrIds: [296],
                    nodeAppId: '299',
                  },
                ],
              },
              {
                nodeId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                nodeAppId: '300',
                nodeAppName: 'cus_sem_dwc_fact_sal_lp_downstream_form_useful_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-03384',
                nodeHoverName: 'LP',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: 'dcb2e58b-5c1d-4e08-821a-ba025e4fc423',
                    nodeChildName: 'address',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [281],
                    nodeAppId: '300',
                  },
                  {
                    nodeChildId: '9a3975c8-7b51-4628-8e1b-f1ff59e1d169',
                    nodeChildName: 'city',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [279],
                    nodeAppId: '300',
                  },
                  {
                    nodeChildId: '106d02a4-ff9d-4e60-a29c-04fdd6ae02d1',
                    nodeChildName: 'first_name',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [269],
                    nodeAppId: '300',
                  },
                  {
                    nodeChildId: '3fe96a8c-6ed7-4dd0-836e-daa303acc3d4',
                    nodeChildName: 'full_name',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [270],
                    nodeAppId: '300',
                  },
                  {
                    nodeChildId: 'c166ce6d-899c-4055-b796-e0628d9f96a2',
                    nodeChildName: 'gender',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [271],
                    nodeAppId: '300',
                  },
                  {
                    nodeChildId: '6ff94356-8119-446d-8e6c-e1eec38784a1',
                    nodeChildName: 'last_name',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [268],
                    nodeAppId: '300',
                  },
                  {
                    nodeChildId: 'df19dc5f-83e6-4574-9b33-143c4ef6e416',
                    nodeChildName: 'mobile_phone_number',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [282],
                    nodeAppId: '300',
                  },
                  {
                    nodeChildId: '1affbeb4-c2fd-4797-aab8-9fd7225ab85f',
                    nodeChildName: 'province',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [278],
                    nodeAppId: '300',
                  },
                  {
                    nodeChildId: '87f2565e-b8ef-42f7-8340-c760d8e4ae90',
                    nodeChildName: 'region',
                    nodeParentId: '684e3393-72cd-4956-8c41-04ec200b2d84',
                    tableId: 300,
                    attrIds: [277],
                    nodeAppId: '300',
                  },
                ],
              },
              {
                nodeId: 'a542799c-2faa-4474-b33e-6ac69d257449',
                nodeAppId: '239',
                nodeAppName: 'cdp_sem_dwc_dim_com_dmo2_t_region_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-01963',
                nodeHoverName: 'DMO',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '8f2de662-3145-4f91-9fcd-49609327cf1b',
                    nodeChildName: 'region_name_cn',
                    nodeParentId: 'a542799c-2faa-4474-b33e-6ac69d257449',
                    tableId: 239,
                    attrIds: [279],
                    nodeAppId: '239',
                  },
                  {
                    nodeChildId: '42f259e0-faf2-409e-bc03-14ce913179c5',
                    nodeChildName: 'parent_region_name_cn',
                    nodeParentId: 'a542799c-2faa-4474-b33e-6ac69d257449',
                    tableId: 239,
                    attrIds: [278],
                    nodeAppId: '239',
                  },
                ],
              },
              {
                nodeId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                nodeAppId: '303',
                nodeAppName: 'cus_sem_dwc_dim_cus_carmen_l_contact_cn_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-00021',
                nodeHoverName: 'CARMEN E/E',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '3b034623-2b83-4fcd-a702-63b75e83a43b',
                    nodeChildName: 'birth_date',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [273],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '39f1e219-e578-4133-b546-bdfe0c28f56a',
                    nodeChildName: 'first_name',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [270],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: 'ead8de4b-b666-4ab3-ae7a-f9b466eab198',
                    nodeChildName: 'last_name',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [268],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '9cee344a-91d0-4908-8c1e-d10ce480ed57',
                    nodeChildName: 'marital_status',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [274],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '094486eb-654d-4a19-933c-d3c3085aa816',
                    nodeChildName: 'mobile_phone_number',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [282],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '3164c7de-d0fa-4428-be5f-7cfcca116b7b',
                    nodeChildName: 'gender',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [271],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '76a7c224-e27c-47b8-b5dc-b5b1ee631b82',
                    nodeChildName: 't1_privacy_cd',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [295],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '0907a750-cf59-4a38-a860-8eaaf48ab156',
                    nodeChildName: 't1_suppress_call_flag',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [295],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '58b0e357-2c47-431f-ba05-57fffd09c01c',
                    nodeChildName: 't1_x_dpa_phone_consent',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [295],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '1feb88ba-7bda-43b7-985f-3e112f425ffc',
                    nodeChildName: 't1_x_dpa_sms_consent',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [294],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '1bc6729e-4d2d-4e45-b7fe-03db497c48ea',
                    nodeChildName: 't1_x_emp_postal_code',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [285],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: 'f5c97349-a01c-4d27-81af-fc43427d8608',
                    nodeChildName: 't1_x_suppress_sms_flag',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [294],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '3570d60f-6d96-4285-992a-c79fde29dcc1',
                    nodeChildName: 'industry',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [300],
                    nodeAppId: '303',
                  },
                  {
                    nodeChildId: '369e82d5-5558-4723-9fd6-183f397956e8',
                    nodeChildName: 'company_name',
                    nodeParentId: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                    tableId: 303,
                    attrIds: [288],
                    nodeAppId: '303',
                  },
                ],
              },
              {
                nodeId: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                nodeAppId: '240',
                nodeAppName: 'cdp_sem_dwc_dim_cus_cop_sys_user_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-19867',
                nodeHoverName: null,
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '0f8a55fe-717b-4332-867c-b8fa86bd07d6',
                    nodeChildName: 'cop_id',
                    nodeParentId: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                    tableId: 240,
                    attrIds: [266],
                    nodeAppId: '240',
                  },
                  {
                    nodeChildId: '1ba38fa2-d0a3-4714-9179-e766719c2bc4',
                    nodeChildName: 'mobile_phone_number',
                    nodeParentId: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                    tableId: 240,
                    attrIds: [282],
                    nodeAppId: '240',
                  },
                  {
                    nodeChildId: '02431c02-bc91-4851-9a54-d1dc326bdd13',
                    nodeChildName: 'last_name',
                    nodeParentId: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                    tableId: 240,
                    attrIds: [268],
                    nodeAppId: '240',
                  },
                  {
                    nodeChildId: '8bb5b58c-aba5-4916-88f8-73729749bd2d',
                    nodeChildName: 'gender',
                    nodeParentId: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                    tableId: 240,
                    attrIds: [271],
                    nodeAppId: '240',
                  },
                  {
                    nodeChildId: '99ea0cd8-f1df-4899-b3e3-e1df711c103e',
                    nodeChildName: 'first_name',
                    nodeParentId: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                    tableId: 240,
                    attrIds: [270],
                    nodeAppId: '240',
                  },
                  {
                    nodeChildId: '4c1780c0-6980-4947-b8db-414ef8c17b62',
                    nodeChildName: 'birth_date',
                    nodeParentId: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                    tableId: 240,
                    attrIds: [273],
                    nodeAppId: '240',
                  },
                ],
              },
              {
                nodeId: '273f2ab5-33dc-4f7c-b237-9773419c863f',
                nodeAppId: '304',
                nodeAppName: 'cus_sem_dwc_fact_com_carmen_b_cx_disclaimer_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-00021',
                nodeHoverName: 'CARMEN E/E',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '93746f97-5c0b-4376-94f9-28fab203e615',
                    nodeChildName: 'disclaimer_status',
                    nodeParentId: '273f2ab5-33dc-4f7c-b237-9773419c863f',
                    tableId: 304,
                    attrIds: [293],
                    nodeAppId: '304',
                  },
                ],
              },
              {
                nodeId: 'ae6be6b6-8130-45e0-8022-9ae1b77f8758',
                nodeAppId: '274',
                nodeAppName: 'cdp_sem_dwc_dim_cus_omc_user_info_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-24557',
                nodeHoverName: 'Open Mobility Cloud Runtime CN Platform',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: 'cf24ecbe-3c5d-421c-a288-54615ac3b112',
                    nodeChildName: 'mobile_phone_number',
                    nodeParentId: 'ae6be6b6-8130-45e0-8022-9ae1b77f8758',
                    tableId: 274,
                    attrIds: [282],
                    nodeAppId: '274',
                  },
                ],
              },
              {
                nodeId: '6cf344b4-4e2d-4afd-b962-f8aabd2b9013',
                nodeAppId: '280',
                nodeAppName: 'cus_sem_dwc_fact_com_omc_cvr_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-24557',
                nodeHoverName: 'Open Mobility Cloud Runtime CN Platform',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: 'd6d3c6ce-8f06-406b-b809-578d3a59a6ce',
                    nodeChildName: 'full_name',
                    nodeParentId: '6cf344b4-4e2d-4afd-b962-f8aabd2b9013',
                    tableId: 280,
                    attrIds: [270],
                    nodeAppId: '280',
                  },
                  {
                    nodeChildId: '631c0453-15de-468e-b281-a72ad6292f68',
                    nodeChildName: 'type',
                    nodeParentId: '6cf344b4-4e2d-4afd-b962-f8aabd2b9013',
                    tableId: 280,
                    attrIds: [267],
                    nodeAppId: '280',
                  },
                ],
              },
              {
                nodeId: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                nodeAppId: '281',
                nodeAppName: 'cus_sem_dwc_dim_cus_cop_address_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-19867',
                nodeHoverName: null,
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '0563c202-b95e-40c0-ac6f-6d12074329c2',
                    nodeChildName: 'city',
                    nodeParentId: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                    tableId: 281,
                    attrIds: [279],
                    nodeAppId: '281',
                  },
                  {
                    nodeChildId: 'fb443dfc-5b43-4a45-ad8c-b380235cee23',
                    nodeChildName: 'country',
                    nodeParentId: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                    tableId: 281,
                    attrIds: [276],
                    nodeAppId: '281',
                  },
                  {
                    nodeChildId: 'a5f5cd82-29ba-4cf9-aded-396895f6c2b6',
                    nodeChildName: 'province',
                    nodeParentId: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                    tableId: 281,
                    attrIds: [278],
                    nodeAppId: '281',
                  },
                  {
                    nodeChildId: '7f3cb370-ae52-4308-8875-c9ed67ca97a8',
                    nodeChildName: 'street',
                    nodeParentId: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                    tableId: 281,
                    attrIds: [281],
                    nodeAppId: '281',
                  },
                ],
              },
              {
                nodeId: 'ff5c274e-307d-46a4-a41e-802e86d66a4d',
                nodeAppId: '282',
                nodeAppName: 'cus_sem_dwc_dim_cus_cop_email_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-19867',
                nodeHoverName: null,
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '7907a839-3790-409c-8cd4-2fc0f7cdcf05',
                    nodeChildName: 'email_address',
                    nodeParentId: 'ff5c274e-307d-46a4-a41e-802e86d66a4d',
                    tableId: 282,
                    attrIds: [283],
                    nodeAppId: '282',
                  },
                ],
              },
              {
                nodeId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                nodeAppId: '314',
                nodeAppName: 'cus_sem_dwc_dim_cus_dmo2_customer_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-01963',
                nodeHoverName: 'DMO',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: 'd45eaaf8-ca45-4d9f-8d3f-fc3f7873184b',
                    nodeChildName: 'email_address',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [284],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: 'a02b5fe3-8ab5-49b1-a62b-1991766bac30',
                    nodeChildName: 'gender',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [271],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: '22cdfa21-7589-48c7-818a-50ee6e437cbc',
                    nodeChildName: 'full_name',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [270],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: '681f8378-05f7-40a5-b9c7-eddc2339fb3e',
                    nodeChildName: 'nationality',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [276],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: '38344c48-3976-445e-8d5e-631e112d356a',
                    nodeChildName: 'customer_group',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [290],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: '273cb88d-63f9-4644-8b7f-5220297f3613',
                    nodeChildName: 'dca_status',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [295],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: '1762fc9a-e6a3-4acc-b7e9-ccd44079e9f1',
                    nodeChildName: 'mobile_phone_number',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [282],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: 'bb255e12-a11f-40ec-a305-c3e2e5eb1111',
                    nodeChildName: 'first_name',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [270],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: 'f65453f7-3251-4397-b9bf-288d6c154d4b',
                    nodeChildName: 'spark_id',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [267],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: '4a4d6cbf-f755-4e20-8614-3200fcd45fdf',
                    nodeChildName: 'last_name',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [268],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: '278cd14b-55d3-436d-9e26-96e825ca9b22',
                    nodeChildName: 'birth_date',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [273],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: '71c77b50-cccb-4240-bae2-6a95946bdb0e',
                    nodeChildName: 'dealer_id',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [267],
                    nodeAppId: '314',
                  },
                  {
                    nodeChildId: 'c49433f8-24ba-4bb4-8099-5f56a7210a99',
                    nodeChildName: 'id_number',
                    nodeParentId: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                    tableId: 314,
                    attrIds: [286],
                    nodeAppId: '314',
                  },
                ],
              },
              {
                nodeId: '85ae5030-c8f9-489c-bfed-f148c64f5d28',
                nodeAppId: '283',
                nodeAppName: 'cus_sem_dwc_dim_cus_cop_policy_history_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-19867',
                nodeHoverName: null,
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '72371eac-7d34-4d46-b729-2d502dff9e7b',
                    nodeChildName: 'policy_id',
                    nodeParentId: '85ae5030-c8f9-489c-bfed-f148c64f5d28',
                    tableId: 283,
                    attrIds: [293],
                    nodeAppId: '283',
                  },
                ],
              },
              {
                nodeId: '98105b70-487c-4c6a-bcbf-03c649101078',
                nodeAppId: '286',
                nodeAppName: 'cus_sem_dwc_dim_cus_gcdm_customer_address_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-15255',
                nodeHoverName: 'GCDM IAM CN',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '30ebeb5f-4b73-490c-8f02-e594d1cf1588',
                    nodeChildName: 'address_checked',
                    nodeParentId: '98105b70-487c-4c6a-bcbf-03c649101078',
                    tableId: 286,
                    attrIds: [281],
                    nodeAppId: '286',
                  },
                  {
                    nodeChildId: 'df3ceef1-a29a-4f36-8f63-65b4eee36233',
                    nodeChildName: 'city',
                    nodeParentId: '98105b70-487c-4c6a-bcbf-03c649101078',
                    tableId: 286,
                    attrIds: [279],
                    nodeAppId: '286',
                  },
                  {
                    nodeChildId: '38c8fca9-0a6c-45f5-86d6-04179cd87fa6',
                    nodeChildName: 'country',
                    nodeParentId: '98105b70-487c-4c6a-bcbf-03c649101078',
                    tableId: 286,
                    attrIds: [276],
                    nodeAppId: '286',
                  },
                  {
                    nodeChildId: '16bfeeec-0ef5-4f43-9f39-c8f65e7915ee',
                    nodeChildName: 'district_name',
                    nodeParentId: '98105b70-487c-4c6a-bcbf-03c649101078',
                    tableId: 286,
                    attrIds: [280],
                    nodeAppId: '286',
                  },
                  {
                    nodeChildId: '09154286-ffb5-4b71-9fc9-38e56795bd50',
                    nodeChildName: 'postcode',
                    nodeParentId: '98105b70-487c-4c6a-bcbf-03c649101078',
                    tableId: 286,
                    attrIds: [285],
                    nodeAppId: '286',
                  },
                ],
              },
              {
                nodeId: '2c962ec7-8a12-42cc-bcd9-bce29624b34c',
                nodeAppId: '287',
                nodeAppName: 'cus_sem_dwc_dim_cus_gcdm_customer_communication_full_t',
                nodeType: 'Original Source',
                serviceName: null,
                nodeProviderAppId: null,
                nodeLegend: null,
                nodeHoverId: 'APP-15255',
                nodeHoverName: 'GCDM IAM CN',
                masterDataNodeChildVos: [
                  {
                    nodeChildId: '76acbecd-7192-4da9-80cc-b23e4ee9d553',
                    nodeChildName: 'value',
                    nodeParentId: '2c962ec7-8a12-42cc-bcd9-bce29624b34c',
                    tableId: 287,
                    attrIds: [283],
                    nodeAppId: '287',
                  },
                ],
              },
            ],
            relations: [
              {
                fromUuid: '02b492ce-cae5-4175-9753-ca4492e82857',
                fromId: 'customer_type',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: '18377b41-2cc9-41f5-8f61-d650297ccd5a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'customer_type',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'da058cb6-a5a2-45ab-a214-f6ee899cd580',
                fromId: 'spark_id',
                parentFromUuid: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                toUuid: '18377b41-2cc9-41f5-8f61-d650297ccd5a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'customer_type',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'e1ba3d81-cdc1-42f3-87d7-cd46b9c6df37',
                fromId: 'dealer_id',
                parentFromUuid: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                toUuid: '18377b41-2cc9-41f5-8f61-d650297ccd5a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'customer_type',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '631c0453-15de-468e-b281-a72ad6292f68',
                fromId: 'type',
                parentFromUuid: '6cf344b4-4e2d-4afd-b962-f8aabd2b9013',
                toUuid: '18377b41-2cc9-41f5-8f61-d650297ccd5a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'customer_type',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'f65453f7-3251-4397-b9bf-288d6c154d4b',
                fromId: 'spark_id',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '18377b41-2cc9-41f5-8f61-d650297ccd5a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'customer_type',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '71c77b50-cccb-4240-bae2-6a95946bdb0e',
                fromId: 'dealer_id',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '18377b41-2cc9-41f5-8f61-d650297ccd5a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'customer_type',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '7e078fee-d5bd-4e89-b9c4-5fbd8b63d50b',
                fromId: 'phone_number',
                parentFromUuid: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                toUuid: '477d6dc9-da06-4d38-b64d-e653b4f65077',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobile_phone_number',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'df19dc5f-83e6-4574-9b33-143c4ef6e416',
                fromId: 'mobile_phone_number',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: '477d6dc9-da06-4d38-b64d-e653b4f65077',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobile_phone_number',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '094486eb-654d-4a19-933c-d3c3085aa816',
                fromId: 'mobile_phone_number',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '477d6dc9-da06-4d38-b64d-e653b4f65077',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobile_phone_number',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '1ba38fa2-d0a3-4714-9179-e766719c2bc4',
                fromId: 'mobile_phone_number',
                parentFromUuid: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                toUuid: '477d6dc9-da06-4d38-b64d-e653b4f65077',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobile_phone_number',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'cf24ecbe-3c5d-421c-a288-54615ac3b112',
                fromId: 'mobile_phone_number',
                parentFromUuid: 'ae6be6b6-8130-45e0-8022-9ae1b77f8758',
                toUuid: '477d6dc9-da06-4d38-b64d-e653b4f65077',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobile_phone_number',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '1762fc9a-e6a3-4acc-b7e9-ccd44079e9f1',
                fromId: 'mobile_phone_number',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '477d6dc9-da06-4d38-b64d-e653b4f65077',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobile_phone_number',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '8cdbe69a-d65e-4dd9-8e10-f8bae72fae30',
                fromId: 'last_name',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: 'd44c5391-2bb1-4c85-9ac5-38bb3544c6d7',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'last_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '6ff94356-8119-446d-8e6c-e1eec38784a1',
                fromId: 'last_name',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: 'd44c5391-2bb1-4c85-9ac5-38bb3544c6d7',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'last_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'ead8de4b-b666-4ab3-ae7a-f9b466eab198',
                fromId: 'last_name',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: 'd44c5391-2bb1-4c85-9ac5-38bb3544c6d7',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'last_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '02431c02-bc91-4851-9a54-d1dc326bdd13',
                fromId: 'last_name',
                parentFromUuid: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                toUuid: 'd44c5391-2bb1-4c85-9ac5-38bb3544c6d7',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'last_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '4a4d6cbf-f755-4e20-8614-3200fcd45fdf',
                fromId: 'last_name',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: 'd44c5391-2bb1-4c85-9ac5-38bb3544c6d7',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'last_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '5ccc7038-b3e1-41a7-a4f7-e4b56cbb5046',
                fromId: 'first_name',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: 'b9bfef12-1089-4ea1-95af-1f8fee55fa5d',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'first_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '106d02a4-ff9d-4e60-a29c-04fdd6ae02d1',
                fromId: 'first_name',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: 'b9bfef12-1089-4ea1-95af-1f8fee55fa5d',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'first_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '3fe96a8c-6ed7-4dd0-836e-daa303acc3d4',
                fromId: 'full_name',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: '9484589b-c587-4516-b3af-be8ca91f23fd',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'full_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '39f1e219-e578-4133-b546-bdfe0c28f56a',
                fromId: 'first_name',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '9484589b-c587-4516-b3af-be8ca91f23fd',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'full_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '99ea0cd8-f1df-4899-b3e3-e1df711c103e',
                fromId: 'first_name',
                parentFromUuid: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                toUuid: '9484589b-c587-4516-b3af-be8ca91f23fd',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'full_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'd6d3c6ce-8f06-406b-b809-578d3a59a6ce',
                fromId: 'full_name',
                parentFromUuid: '6cf344b4-4e2d-4afd-b962-f8aabd2b9013',
                toUuid: '9484589b-c587-4516-b3af-be8ca91f23fd',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'full_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '22cdfa21-7589-48c7-818a-50ee6e437cbc',
                fromId: 'full_name',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '9484589b-c587-4516-b3af-be8ca91f23fd',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'full_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'bb255e12-a11f-40ec-a305-c3e2e5eb1111',
                fromId: 'first_name',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '9484589b-c587-4516-b3af-be8ca91f23fd',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'full_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '227c7de5-b58d-4390-8e2a-3c9ddd1d7f25',
                fromId: 'gender',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: '6557c006-872b-4b2c-98f7-a20c118d78b5',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'gender',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'c166ce6d-899c-4055-b796-e0628d9f96a2',
                fromId: 'gender',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: '6557c006-872b-4b2c-98f7-a20c118d78b5',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'gender',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '3164c7de-d0fa-4428-be5f-7cfcca116b7b',
                fromId: 'gender',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '6557c006-872b-4b2c-98f7-a20c118d78b5',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'gender',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '8bb5b58c-aba5-4916-88f8-73729749bd2d',
                fromId: 'gender',
                parentFromUuid: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                toUuid: '6557c006-872b-4b2c-98f7-a20c118d78b5',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'gender',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'a02b5fe3-8ab5-49b1-a62b-1991766bac30',
                fromId: 'gender',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '6557c006-872b-4b2c-98f7-a20c118d78b5',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'gender',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '18a9cfde-afaf-4bb1-b30c-97a007ea5ed1',
                fromId: 'birth_date',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: '10ffb3a7-348f-4d54-ac58-a1228dc04f0b',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'birth_date',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '3b034623-2b83-4fcd-a702-63b75e83a43b',
                fromId: 'birth_date',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '10ffb3a7-348f-4d54-ac58-a1228dc04f0b',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'birth_date',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '4c1780c0-6980-4947-b8db-414ef8c17b62',
                fromId: 'birth_date',
                parentFromUuid: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                toUuid: '10ffb3a7-348f-4d54-ac58-a1228dc04f0b',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'birth_date',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '278cd14b-55d3-436d-9e26-96e825ca9b22',
                fromId: 'birth_date',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '10ffb3a7-348f-4d54-ac58-a1228dc04f0b',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'birth_date',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '6f2e0dcd-15d9-4837-92db-71b4568e1710',
                fromId: 'marital_status',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: '52d75026-1f01-4f95-a1f4-c06f89c73607',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'marital_status',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '9cee344a-91d0-4908-8c1e-d10ce480ed57',
                fromId: 'marital_status',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '52d75026-1f01-4f95-a1f4-c06f89c73607',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'marital_status',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'fb443dfc-5b43-4a45-ad8c-b380235cee23',
                fromId: 'country',
                parentFromUuid: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                toUuid: '2abe13c9-d434-41bc-a715-74fa9074edca',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'country',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '681f8378-05f7-40a5-b9c7-eddc2339fb3e',
                fromId: 'nationality',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '2abe13c9-d434-41bc-a715-74fa9074edca',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'country',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '38c8fca9-0a6c-45f5-86d6-04179cd87fa6',
                fromId: 'country',
                parentFromUuid: '98105b70-487c-4c6a-bcbf-03c649101078',
                toUuid: '2abe13c9-d434-41bc-a715-74fa9074edca',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'country',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '87f2565e-b8ef-42f7-8340-c760d8e4ae90',
                fromId: 'region',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: '39218060-a528-4409-94e1-57fd157e4e00',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'region',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '1affbeb4-c2fd-4797-aab8-9fd7225ab85f',
                fromId: 'province',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: 'bdd426b5-2c3d-4b87-a7b6-f24e0495480a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'province',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '42f259e0-faf2-409e-bc03-14ce913179c5',
                fromId: 'parent_region_name_cn',
                parentFromUuid: 'a542799c-2faa-4474-b33e-6ac69d257449',
                toUuid: 'bdd426b5-2c3d-4b87-a7b6-f24e0495480a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'province',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'a5f5cd82-29ba-4cf9-aded-396895f6c2b6',
                fromId: 'province',
                parentFromUuid: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                toUuid: 'bdd426b5-2c3d-4b87-a7b6-f24e0495480a',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'province',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '9a3975c8-7b51-4628-8e1b-f1ff59e1d169',
                fromId: 'city',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: '9270ca16-6847-49c0-8208-4a0f774abbbb',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'city',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '8f2de662-3145-4f91-9fcd-49609327cf1b',
                fromId: 'region_name_cn',
                parentFromUuid: 'a542799c-2faa-4474-b33e-6ac69d257449',
                toUuid: '9270ca16-6847-49c0-8208-4a0f774abbbb',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'city',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '0563c202-b95e-40c0-ac6f-6d12074329c2',
                fromId: 'city',
                parentFromUuid: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                toUuid: '9270ca16-6847-49c0-8208-4a0f774abbbb',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'city',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'df3ceef1-a29a-4f36-8f63-65b4eee36233',
                fromId: 'city',
                parentFromUuid: '98105b70-487c-4c6a-bcbf-03c649101078',
                toUuid: '9270ca16-6847-49c0-8208-4a0f774abbbb',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'city',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '16bfeeec-0ef5-4f43-9f39-c8f65e7915ee',
                fromId: 'district_name',
                parentFromUuid: '98105b70-487c-4c6a-bcbf-03c649101078',
                toUuid: '7a0db5c3-98b9-4d14-9ce5-60d4f0f24e2c',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'district',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '75bcc6a3-7bc8-405d-8cee-7e361884bc43',
                fromId: 'address_detail',
                parentFromUuid: 'be94fe92-051e-45c1-9626-9c7f00955f15',
                toUuid: '8406a1c7-ba37-470f-b3d0-40f1cf1bf840',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'address',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '75d0cdf3-0ebe-4866-87f3-03b45cea4c4d',
                fromId: 'address',
                parentFromUuid: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                toUuid: '8406a1c7-ba37-470f-b3d0-40f1cf1bf840',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'address',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'dcb2e58b-5c1d-4e08-821a-ba025e4fc423',
                fromId: 'address',
                parentFromUuid: '684e3393-72cd-4956-8c41-04ec200b2d84',
                toUuid: '8406a1c7-ba37-470f-b3d0-40f1cf1bf840',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'address',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '7f3cb370-ae52-4308-8875-c9ed67ca97a8',
                fromId: 'street',
                parentFromUuid: '646f77f8-d5f0-4c8a-ba38-979401a8da18',
                toUuid: '8406a1c7-ba37-470f-b3d0-40f1cf1bf840',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'address',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '30ebeb5f-4b73-490c-8f02-e594d1cf1588',
                fromId: 'address_checked',
                parentFromUuid: '98105b70-487c-4c6a-bcbf-03c649101078',
                toUuid: '8406a1c7-ba37-470f-b3d0-40f1cf1bf840',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'address',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '7907a839-3790-409c-8cd4-2fc0f7cdcf05',
                fromId: 'email_address',
                parentFromUuid: 'ff5c274e-307d-46a4-a41e-802e86d66a4d',
                toUuid: 'e1ae321a-9260-4c8b-94d2-676b7d6c556c',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'email_address_business',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '76acbecd-7192-4da9-80cc-b23e4ee9d553',
                fromId: 'value',
                parentFromUuid: '2c962ec7-8a12-42cc-bcd9-bce29624b34c',
                toUuid: 'e1ae321a-9260-4c8b-94d2-676b7d6c556c',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'email_address_business',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'd45eaaf8-ca45-4d9f-8d3f-fc3f7873184b',
                fromId: 'email_address',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '8d744632-7854-49bc-ac5f-d45a506c2e43',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'email_address_private',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '6a9222e2-eeae-4216-abca-5230ecae76c5',
                fromId: 'postcode',
                parentFromUuid: 'be94fe92-051e-45c1-9626-9c7f00955f15',
                toUuid: 'ab5f5e91-6fac-4b2f-b2f6-18faf79ea3d4',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'postcode',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '1bc6729e-4d2d-4e45-b7fe-03db497c48ea',
                fromId: 't1_x_emp_postal_code',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: 'ab5f5e91-6fac-4b2f-b2f6-18faf79ea3d4',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'postcode',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '09154286-ffb5-4b71-9fc9-38e56795bd50',
                fromId: 'postcode',
                parentFromUuid: '98105b70-487c-4c6a-bcbf-03c649101078',
                toUuid: 'ab5f5e91-6fac-4b2f-b2f6-18faf79ea3d4',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'postcode',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '62721a06-8996-44f6-8952-a2e54308debf',
                fromId: 'profession',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: '4245b29d-3656-4ba0-8ad8-02d39cb07f48',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'profession',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '3570d60f-6d96-4285-992a-c79fde29dcc1',
                fromId: 'industry',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: 'b5405f5e-60ad-41ea-ac5d-2682f5b314d4',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'industry',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '0c154048-03ce-4cd0-8e78-51f26fb7fb19',
                fromId: 'hobby',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: '351eab7c-0aee-4492-b91b-1650b673873b',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'hobby',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'c49433f8-24ba-4bb4-8099-5f56a7210a99',
                fromId: 'id_number',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '83196291-fc98-46d8-83f1-cf4eaff22034',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'id_number',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '83680182-bc67-4fd5-ad1b-8e0ea15f2319',
                fromId: 'company_name',
                parentFromUuid: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                toUuid: '5f217193-3ab4-4587-9d76-9939f59c1ce3',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'company_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '369e82d5-5558-4723-9fd6-183f397956e8',
                fromId: 'company_name',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '5f217193-3ab4-4587-9d76-9939f59c1ce3',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'company_name',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '5f3623dd-3d28-4053-b928-e482991915c5',
                fromId: 'taxpayer_identity_number',
                parentFromUuid: '3f723da5-b16a-4eb9-bee8-6726a2a6009a',
                toUuid: 'ef8d3285-7f00-4fdb-8683-41330e862d3c',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'taxpayer_identity_number',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '860ed516-2cf0-4c61-9e8f-66f54579c677',
                fromId: 'customer_group',
                parentFromUuid: '1bf62138-b3d4-48d8-97f3-9a704093d519',
                toUuid: '5dd56bda-778f-497c-ba27-17662c6577ac',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'customer_group',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '38344c48-3976-445e-8d5e-631e112d356a',
                fromId: 'customer_group',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '5dd56bda-778f-497c-ba27-17662c6577ac',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'customer_group',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '93746f97-5c0b-4376-94f9-28fab203e615',
                fromId: 'disclaimer_status',
                parentFromUuid: '273f2ab5-33dc-4f7c-b237-9773419c863f',
                toUuid: 'ee0bf166-ed6d-4b0f-9f03-22b79dfd3c3c',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '72371eac-7d34-4d46-b729-2d502dff9e7b',
                fromId: 'policy_id',
                parentFromUuid: '85ae5030-c8f9-489c-bfed-f148c64f5d28',
                toUuid: 'ee0bf166-ed6d-4b0f-9f03-22b79dfd3c3c',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '76a7c224-e27c-47b8-b5dc-b5b1ee631b82',
                fromId: 't1_privacy_cd',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '7803ab67-68cb-499d-9fa1-c852040a8c0d',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobilephone_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '0907a750-cf59-4a38-a860-8eaaf48ab156',
                fromId: 't1_suppress_call_flag',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '7803ab67-68cb-499d-9fa1-c852040a8c0d',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobilephone_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '58b0e357-2c47-431f-ba05-57fffd09c01c',
                fromId: 't1_x_dpa_phone_consent',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '7803ab67-68cb-499d-9fa1-c852040a8c0d',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobilephone_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '273cb88d-63f9-4644-8b7f-5220297f3613',
                fromId: 'dca_status',
                parentFromUuid: '38ce8376-c793-4ee6-8c58-ff8ab3a06988',
                toUuid: '7803ab67-68cb-499d-9fa1-c852040a8c0d',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mobilephone_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'b566bb51-b5e3-47e7-b7a8-6c95c98e1c6d',
                fromId: 'data_usage_revoked',
                parentFromUuid: 'f3a47e30-7467-4bb0-ba7a-976a1acff9c7',
                toUuid: 'cde14d12-c34a-4426-97a9-cd33bb6f7fd0',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'email_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '30007713-6d2c-48ec-9d0e-11b5248122f2',
                fromId: 'data_usage_type',
                parentFromUuid: 'f3a47e30-7467-4bb0-ba7a-976a1acff9c7',
                toUuid: 'cde14d12-c34a-4426-97a9-cd33bb6f7fd0',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'email_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '1feb88ba-7bda-43b7-985f-3e112f425ffc',
                fromId: 't1_x_dpa_sms_consent',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '48c23da7-0d3c-4ac9-ae4f-b71c1af0261c',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mms_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: 'f5c97349-a01c-4d27-81af-fc43427d8608',
                fromId: 't1_x_suppress_sms_flag',
                parentFromUuid: 'a020f322-f71a-4641-a8ff-bd526c5b900f',
                toUuid: '48c23da7-0d3c-4ac9-ae4f-b71c1af0261c',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'mms_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '668231bf-10e4-4e85-a787-7f26790dc8d5',
                fromId: 'subscribe_status',
                parentFromUuid: '8c71b891-77bc-4e4e-8b6d-e5d4e1c33a86',
                toUuid: '8b465191-f823-4d7e-bdfa-9ee1116ebe23',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'wechat_optin_optout',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
              {
                fromUuid: '0f8a55fe-717b-4332-867c-b8fa86bd07d6',
                fromId: 'cop_id',
                parentFromUuid: '25ca60f8-6bcb-4265-9bc7-8ffd85f7de1b',
                toUuid: 'e02a6f16-7b77-4a91-8d17-0d20763ad466',
                parentToUuid: '41850751-300e-4168-9ee9-f21a756eb386',
                toId: 'cop_id',
                relationName: null,
                legend: null,
                relationType: 'Original Source',
              },
            ],
          },
        ],
      },
    },
  },
};
